import FeatureToggleSelector from "features/featureToggles/FeatureToggleSelector";
import { useRoutes } from "react-router";
import routeConfig from "routes/routeConfig";
import { useLocale } from "features/i18n/useLocale";
import "./App.less";
import { registerSparkComponents } from "genesys-spark";
import { useEffect, useState } from "react";
import { LoadingSpinner } from "react/components/LoadingSpinner";
import { GlobalAnnouncementRegion } from "react/components/GlobalAnnouncementRegion";

export const App = () => {
    const routes = useRoutes(routeConfig);
    const locale = useLocale();

    const [sparkLoading, setSparkLoading] = useState(true);

    useEffect(() => {
        const initSpark = async () => {
            try {
                setSparkLoading(true);
                await registerSparkComponents({
                    theme: "flare",
                });
            } catch (err) {
                console.error("Spark Theme loading failed:", err);
            } finally {
                setSparkLoading(false);
            }
        };

        initSpark();
    }, []);

    return (
        <div className="quality-forms-app" lang={locale}>
            <GlobalAnnouncementRegion />
            {sparkLoading ? (
                <LoadingSpinner />
            ) : (
                <>
                    {routes}
                    <FeatureToggleSelector></FeatureToggleSelector>
                </>
            )}
        </div>
    );
};
